import api from '@/utils/api'
import store from '@/store'
import { ua } from '@/utils/browser'
import { getParams } from '@/utils/url'

const UrlModel = getParams('model')
const uaParam = encodeURIComponent(`${ua}-${UrlModel}`)
const is_sm = getParams('is_sm') || 0  //模拟器判断参数 //1是模拟器，0非模拟器

const commonParams = {
    get game_id() {
        return store.state.app.appConfig.game_id
    },
    get platform() {
        return store.state.app.appConfig.platform
    },
    get muid() {
        return store.state.app.appConfig.muid
    },
}

/* 登录：token登录 */
/**
 * 在线时长打点
 * @author hj
 * @date 2021/12/20
 * @param { string } params.token
 * @param { string } params.game_id
 * */
export const tokenLogin = (params) => {
    return api.post('/game/token-login', {
        is_sm: is_sm,
        ...commonParams,
        ...params,
    })
}

/** 谷歌登录 */
export const googleLogin = (params) => {
    return api.post('/Login/GoogleLogin', {
        is_sm: is_sm,
        ...commonParams,
        ...params,
    })
}

/* 登录：手机登录/账号密码登录 */
export const userLogin = (params) => {
    return api.post('/login/login', {
        is_sm: is_sm,
        ...commonParams,
        ...params,
    })
}

/** 注册
 * @param params
 *  */
export const userRegister = (params) => {
    return api.post('/frontUser/register', {
        is_sm: is_sm,
        ua: uaParam,
        ...commonParams,
        ...params,
    }, {
        messageSilent: true,
    })
}

/* 发送验证码 */
export const sendVerifyCode = (params) => api.post('/Email/sendCode', {
    ...commonParams,
    ...params,
})
/* 获取用户信息 */
/**@param params { {user_token?: string, username?:string, platform?: string | number }}*/
export const getUserDetail = (params) => api.post('/frontUser/userDetail', {
    user_token: store.state.accountData.user_token,
    username: store.state.accountData.username,
    platform: commonParams.platform,
    ...params,
})

/* 实名认证 */
export const certificate = (params) => api.post('/certification/certification',
    {
        user_token: store.state.accountData.user_token,
        ...commonParams,
        ...params,
    })

/* 绑定手机 */
/**@param params { {user_token?: string, mobile?:string | number, code?: string | number}}*/
// export const mobileBind = (params) => api.post('/common/mobileBind', {
//     user_token: store.state.accountData.user_token,
//     ...commonParams,
//     ...params,
// })

/* 重新绑定手机 */
/**@param params { {email:(string | number), code: (string | number), update: 0 | 1 }}*/
export const mobileRebind = (params) => api.post('/common/setEmail', {
    user_token: store.state.accountData.user_token,
    ...commonParams,
    ...params,
})

/* 重设密码by邮箱 */
/** @param params {{ email: string, code: string| number, repassword: string, password: string }} */
export const resetPasswordEmail = (params) => api.post(
    '/forgetPassword/ForgetPasswordEmail', {
    ...commonParams,
    ...params,
})

/* 重设密码 */
/** @param params {{ mobile: string,code: string| number, repassword: string, password: string }} */
export const resetPassword = (params) => api.post(
    '/forgetPassword/ForgetPassword', {
    ...commonParams,
    ...params,
})

/** @param params {{ user_token: string, newpassword: string repassword: string, password: string }} */
export const changePassword = (params) => api.post('/frontUser/changePassword',
    {
        user_token: store.state.accountData.user_token,
        ...commonParams,
        ...params,
    })

/* wx下单 */
export const wechatPayment = (params) => api.get('/pay/shell-package-h5', {
    params: {
        ...params,
        ua: uaParam,
    },
})

/* 激活采集接口 */
export const collectActive = (params) => api.post('/collect/atv', {
    ua: uaParam,
    ...params,
})

export const gameService = (params) => api.post('/Game/service', params)

// 2022.05.17 检测新旧注册用户加载不同游戏链接
export const checkGameUser = (params) => api.get('/game/check-link', { params })

/** @param params {{ game_id: string }} */
export const initH5 = (params) => api.get('/game/h5-init', { params })

/** @param params {{ game_id: string back: string username: string }} */
export const bakLogin = (params) => api.get('/game/bak-login', { params })

/*SDK接口*/
/**
 * 激活上报
 * @param { string } params.role        - 角色名
 * @param { string } params.role_id     - 角色ID
 * @param { string } params.server_name - 区服名称
 * @param { string } params.server_id   - 区服ID
 * */
export const collectGameActive = (params) => api.post('/collect/gameActive', {
    ...params,
})

/**
 * 创角上报
 * @param { string } userData.role      - 角色名
 * @param { string } userData.server_id - 区服ID
 * */
export const createNewRole = (userData) => api.post('/collect/createRole', {
    ...userData,
})

/**
 * 波克支付上报
 * @param { 'wx' | 'ali' } gameData.pay_type     - 支付方式
 * @param { string } gameData.pay_money          - 支付金额
 * @param { string } gameData.order_money        - 订单金额
 * @param { string } gameData.goods_id           - 商品ID
 * @param { string } gameData.goods_name         - 商品名
 * @param { string } gameData.server_id          - 区服ID
 * @param { string } gameData.server_name        - 区服名称
 * @param { string } gameData.role               - 角色名
 * @param { string } gameData.role_id            - 角色ID
 * @param { string } gameData.server_id          - 区服ID
 * @param { JSON } gameData.data                 - 备用字段
 * @param { string } gameData.ext                - 订单号
 * @param { string } gameData.pay_sign           - 支付签名
 *                                               - 规则：md5(username+order_money+timestamp+研发订单号+game_key)
 * @param { string } gameData.timestamp          - 时间戳
 * */
export const collectBkPay = (gameData) => api.post('/WapPay/collectBkPay', {
    ...gameData,
})

/**
 * 特定等级上报
 * @param { string } params.level     - 角色等级
 * @param { string } params.role      - 角色名
 * @param { string } params.role_id   - 角色ID
 * @param { string } params.server_id - 区服ID
 * */
export const collectRoleLevel = (params) => api.post('/collect/level', {
    ...params,
})

/**
 * 在线时长打点
 * @author Carson
 * @date 2021/2/1
 * @param { string } params.username
 * @param { string } params.game_id
 * @param { string } params.platform
 * @param { string } params.sys_platform
 * */
export const collectPlayTime = (params) => {
    return api.post('/Collect/identityAuthentication', {
        ...params,
    }, {
        messageSilent: true,
    })
}

/**（微信浏览器内）
 * 试验方案一：登录后传递游戏ID和username到服务器，服务器重定向获取openID
 * 试验方案一结果：未实现需求，单独接口在微信内打开可获取，在项目使用get请求返回状态码0，后续可查找原因
 * 
 * 最终试验方案：传递传递game_id auth_code到服务器，服务器获取openID返回给前端，前端保存到本地
 * 最终试验方案结果：已实现
 * @description 
 * @author Carson
 * @change hj
 * @date 2021/7/1
 * @lastdate 2021/9/14
 * @param { string } params.game_id
 * */

export const getWxAuthOpenid = (params) => {
    return api.get('/wx/oauth-openid', {
        params: {
            pay_type: 'inner_wx',
            ...params,
        },
        pureParams: true,
        messageSilent: true,
    })
}

/**
 * @description 方案一使用（微信浏览器内）获取用户微信openid（用于微信内的操作，如支付）
 * @author Carson
 * @date 2021/7/1
 * @param { string } params.game_id
 * @param { string } params.username
 * */
export const getUserOpenid = (params) => {
    return api.get('/wx/get_user_openid', { params })
}


/**
 * 获取礼包码列表
 * @param { string } params.user_token  
 * @param { string } params.game_id   - 游戏ID
 * */
 export const getCodeList = (params) => api.post('/Gift/getCodeList', {
    user_token: store.state.accountData.user_token,
    ...params,
})


/**
 * 获取我的礼包码列表
 * @param { string } params.user_token  
 * @param { string } params.game_id   - 游戏ID
 * */
 export const getMyCode = (params) => api.post('/Gift/getMyCode', {
    user_token: store.state.accountData.user_token,
    ...params,
})


/**
 * 上报礼包码领取
 * @param { string } params.user_token  
 * @param { string } params.game_id   - 游戏ID
 * @param { string } params.gift_id   - 礼包码id
 * */
 export const receiveCode = (params) => api.post('/Gift/receiveCode', {
    user_token: store.state.accountData.user_token,
    ...params,
})


/**
 * 获取弹框公告
 * @param { string } params.user_token  
 * @param { string } params.game_id   - 游戏ID
 * */
 export const getNewNotice = (params) => api.post('/Notice/getNewNotice', {
    ...params,
})


/**
 * 是否显示转端升级有礼图标UI
 * @param { string } params.game_id 游戏ID
 * @param { string } params.switch_level 转端游戏等级
 * @param { string } params.switch_vip_level 转端vip等级
 * @param { string } params.switch_money 转端累计充值
 * */
 export const checkUpgradeUI = (params) => api.get('/game/check-switch', { params })


 /**
 * 获取个人信息收集清单
 * @param { string } params.username 用户名
 * */
  export const getPrivacyPolicy = (params) => api.post('/frontUser/userInfoList', { ...params })


/**
 * 查询切支付路径
 * @param { string } params.gid 游戏ID
 * @param { string } params.rl 角色等级
 * @param { string } params.username 用户名
 * */
 export const getPayType = (params) => api.get('/Certification/newCache', { params })


/**
 * 微信公众号下单接口
 * */
 export const queryWxPayOrder = (params) => api.get('pay/public-to-order', { params })

 // 订单状态查询
export const queryOrderStatus= (params) => api.post('/wapPay/orderStateQuery', { ...params })

/** 领取优惠券 */
export const activeCouponReq = (params) => api.post('/frontUser/getCoupon', { ...commonParams, ...params })

/** 可用优惠券 */
export const useableCouponReq = (params) => api.post('/frontUser/usableCoupon', { ...commonParams, ...params })
